/**
 * Size distribution of a goods-receipt line (mirrors PurchaseOrderItemBreakdown / 0108).
 * Path: org/{orgId}/goods-receipt/{goodsReceiptId}/item/{itemId}/breakdown
 */
export const GOODS_RECEIPT_ITEM_BREAKDOWN = 'GoodsReceiptItemBreakdown';
//# sourceMappingURL=goods-receipt-item-breakdown.js.map